<template>
    <div :class="$style.footer">
        <div>
            <el-popover
                ref="popover5"
                placement="top"
                width="160"
                v-model="visible">
                <p>确定清空吗？</p>
                <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                    <el-button type="primary" size="mini" @click="delAll">确定</el-button>
                </div>
            </el-popover>
            <el-button v-popover:popover5 style="background: transparent;border: 0">清空购物车</el-button>
        </div>
        <div :class="$style.right">
            <Cart :list="cartProducts">
                    <span style="cursor: pointer">
                        <span :class="$style.cart">
                            <svg :class="$style.icon" aria-hidden="true">
                                <use xlink:href="#icon-cart"></use>
                            </svg>
                        </span>已选<small style="color: #f74845"> {{quantity}} </small>件商品</span>
            </Cart>

            <span>总计： <small style="color: #f74845">  {{total}} </small></span>
            <el-button @click="goToPay">去支付</el-button>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Cart from './Cart.vue';
    import { setCartProducts } from '../../stores/api';

    Vue.component('Cart', Cart);

    export default {
        props: ['cartProducts', 'getCartProducts'],
        data () {
            return {
                visible: false,
                btnLoading: false,
//                cartProducts: [],
            };
        },
        methods: {
            delAll () {
                if (this.cartProducts.length <= 0) {
                    this.$notify.success({
                        title: '操作成功',
                        message: '已清空购物车',
                    });
                    this.visible = false;
                    return;
                }
                this.btnLoading = true;
                try {
                    this.cartProducts.forEach(async (item) => {
                        await setCartProducts(item.rec_id, 0);
                    });
                    this.$notify.success({
                        title: '操作成功',
                        message: '已清空购物车',
                    });
                } catch (err) {
                    this.$notify.error({
                        title: '操作失败',
                        message: err.message,
                    });
                }
                this.getCartProducts();
                this.visible = false;
                this.btnLoading = false;
            },
            goToPay() {
                this.$router.push('/SupplyChain');
                window.$('main').scrollTop(0);
            },
        },
        computed: {
            quantity () {
                let quantity = 0;
                this.cartProducts.forEach(item => {
                    quantity += item.goods_number;
                });
                return quantity;
            },
            total () {
                let total = 0;
                this.cartProducts.forEach(item => {
                    total += item.goods_number * Number(item.goods_price_no);
                });
                return '￥' + total.toFixed(2);
            }
        }
    };
</script>
<style lang="less" module>
    @import '../../default';

    .footer {
        background: #e8e9eb;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        .right {
            & > span {
                height: 100%;
                display: inline-block;
                span {
                    height: 100%;
                    display: inline-block;
                    margin-right: 20px;
                }
                small {
                    font-size: 16px;
                }
            }

            button {
                height: 40px;
                min-height: 35px;
                min-width: 80px;
                margin-left: 10px;
                padding: 0;
                background: @orange !important;
                color: #FFF !important;
                font-size: 16px;
                text-align: center;
                border: 0;
                border-radius: 0;
            }
            .cart {
                width: 25px;
                height: 25px;
                margin-right: 5px;
                vertical-align: baseline;
                text-align: center;
                line-height: 28px;
                display: inline-block;
                background: #b6b6b8;
                border-radius: 50%;
                .icon {
                    width: 15px;
                    height: 15px;
                    fill: #FFF;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/AddPro/Footer.vue